import { apiSlice } from 'state/slices/apiSlice';

const PROFILE_URL = '/me';

export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateProfile: builder.mutation({
      query: (data) => {
        return {
          url: `${PROFILE_URL}/profile/update`,
          method: 'PUT',
          body: data,
        };
      },
    }),
    getProfile: builder.query({
      query: () => `${PROFILE_URL}/profile`,
    }),
    getTimezones: builder.query({
      query: () => '/timezones',
    }),
  }),
});

export const {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useGetTimezonesQuery,
} = profileApiSlice;
